module.exports = __webpack_public_path__ + "static/media/Celebration.d7de50ae.svg";